import { Box } from 'foundations-components/transitional/components/Box';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AiSearchResultItemSkeleton = () => {
  return /*#__PURE__*/_jsxs(GridItem, {
    size: {
      sm: 12,
      md: 6
    },
    marginBlock: "0",
    marginBlockEnd: "300",
    marginInline: "0",
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(AISkeleton, {
        shape: "rect",
        height: 400,
        width: '100%'
      })
    }), /*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(AISkeleton, {
        shape: "rect",
        height: 12,
        width: '100%'
      })
    }), /*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(AISkeleton, {
        shape: "rect",
        height: 12,
        width: '100%'
      })
    }), /*#__PURE__*/_jsx(AISkeleton, {
      shape: "rect",
      height: 12,
      width: '50%'
    })]
  });
};
export default AiSearchResultItemSkeleton;